import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { CollectSessionType, DeviceOptionType, UserOptionType, AreaOptionType } from './types'

interface EditProps {
  collect_session: CollectSessionType
  devices: DeviceOptionType[]
  users: UserOptionType[]
  areas: AreaOptionType[]
}

export default function Edit({ collect_session, devices, users, areas }: EditProps) {
  return (
    <>
      <Head title="Editing collect session" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing collect session</h1>

        <Form
          collect_session={collect_session}
          devices={devices}
          users={users}
          areas={areas}
          action={`/collect_sessions/${collect_session.id}`}
          method="patch"
          submitText="Update Collect session"
        />

        <Link
          href={`/collect_sessions/${collect_session.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Show this collect session
        </Link>
        <Link
          href="/collect_sessions"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to collect sessions
        </Link>
      </div>
    </>
  )
}
